import { useTranslation } from 'react-i18next';

import { PAGE_SIZE } from '@/constants';
import { AssetType } from '@/enums';
import { AssetGridPicker } from '@/pages/DigitalSignage/DeviceManagement/Tab/components/AssetGridPicker';
import { useGetEventAssets } from '@/services';
import { Asset, SelectOptionProps } from '@/types';

interface EventAssetsPickerProps {
  selectedEvent: SelectOptionProps | null;
  selectedAssetId: number | null;
  onAssetSelect: (asset: Asset) => void;
}

export const EventAssetsPicker = ({
  selectedEvent,
  selectedAssetId,
  onAssetSelect
}: EventAssetsPickerProps) => {
  const [t] = useTranslation('common');

  const selectedEventValue = selectedEvent?.value?.toString() ?? '';
  const isEventSelected = !!selectedEventValue;
  const allowedAssetTypes = Object.values(AssetType)
    .filter(
      (type) =>
        type !== AssetType.TEXT && type !== AssetType.STOCK_CLIPS && typeof type === 'number'
    )
    .map((type) => type.toString());

  const {
    data: eventAssets,
    isLoading: isLoadingAssets,
    fetchNextPage,
    hasNextPage
  } = useGetEventAssets(
    selectedEventValue,
    [],
    PAGE_SIZE,
    undefined,
    allowedAssetTypes,
    undefined,
    true,
    isEventSelected
  );

  const assets = eventAssets?.pages.flatMap((page) => page.data?.items as Asset[]) ?? [];

  if (!selectedEvent) {
    return null;
  }

  return (
    <AssetGridPicker
      assets={assets}
      selectedAssetId={selectedAssetId}
      onAssetSelect={onAssetSelect}
      isLoading={isLoadingAssets}
      emptyLabel={t('noAssetsFound')}
      hasNextPage={hasNextPage}
      fetchNextPage={fetchNextPage}
    />
  );
};
